import styled from "styled-components";

export const ControllerSitInReservationWrapper = styled.div<{
  isWide: boolean;
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${(p) => (p.isWide ? "500px" : "calc(100% - 32px)")};
  height: ${(p) => (p.isWide ? "487px" : "auto")};
  border-radius: 13px;
  background: #fff;
  z-index: 100;
  padding: 40px 15px 23px;
  box-sizing: border-box;

  > .title {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
    color: #121212;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > img {
      cursor: pointer;
      margin-right: 8px;
    }
  }
`;

export const ControllerReservationListWrapper = styled.div<{
  isWide: boolean;
}>`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 9px;
  height: ${(p) => (p.isWide ? "260px" : "180px")};

  .date {
    width: 20%;
  }

  .name {
    width: 30%;
  }

  .phone {
    width: 22%;
  }

  .button {
    width: 12%;
  }
`;

export const ControllerReservationListHeader = styled.div<{ isWide: boolean }>`
  display: flex;
  font-family: Pretendard;
  font-weight: 600;
  font-size: ${(p) => (p.isWide ? "13px" : "11px")};
  line-height: 100%;
  text-align: center;
  padding: 0 15px;
  gap: 5px;
`;

export const ControllerReservationListBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ControllerReservationListItem = styled.div<{ isWide: boolean }>`
  display: flex;
  background: #ecf0f3;
  width: 100%;
  height: ${(p) => (p.isWide ? "45px" : "30px")};
  border-radius: 15px;
  padding: ${(p) => (p.isWide ? "10px 15px" : "10px 6px")};
  box-sizing: border-box;
  align-items: center;
  gap: ${(p) => (p.isWide ? "5px" : "3px")};

  font-family: Pretendard;
  font-weight: 600;
  font-size: ${(p) => (p.isWide ? "12px" : "11px")};
  line-height: 100%;
  text-align: center;
  color: #121212;

  > .button {
    background: #6436e7;
    color: #fff;
    cursor: pointer;
    border-radius: ${(p) => (p.isWide ? "10px" : "90px")};
    padding: ${(p) => (p.isWide ? "10px 0" : "4px 0px")};
  }
`;
